module.exports = __webpack_public_path__ + "img/envelope.971dcc3b.svg";